import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoacheeSettingsState {
	isDisassociatingCoach: boolean;
	isSavingNotifications: boolean;
	isSavingInformation: boolean;
	isUpdatingMfa: boolean;
}

@Injectable()
export class CoacheeSettingsStore extends Store<CoacheeSettingsState> {
	constructor() {
		super(
			{ isDisassociatingCoach: false },
			{ name: `ui-coachee-settings-${guid()}` }
		);
	}
}
